/* ============
 * Mutations for the cvc module
 * ============
 *
 * The mutations that are available on the
 * cvc module.
 */

export default {
  setUser (state, payload) {
    state.user = payload.data
  },
  setCVCParams (state, payload) {
    state.cvcParams = payload
  },
  clear (state) {
    state.user = null
    state.cvcParams = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cvc/mutations.js